import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=f96dd216&scoped=true&"
import script from "./ReferAFriend.vue?vue&type=script&lang=js&"
export * from "./ReferAFriend.vue?vue&type=script&lang=js&"
import style0 from "./ReferAFriend.vue?vue&type=style&index=0&id=f96dd216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96dd216",
  null
  
)

export default component.exports